import React from 'react';
import PropTypes from 'prop-types';
import BeRemoteErrorAlert from 'client/components/Be/BeRemoteErrorAlert';
import BeLoading from 'client/components/Be/BeLoading';
import { ButtonWaiting } from 'client/components/Button/ButtonWaiting';

function EATDTesterChange ({
  changeId,
  changeNumber,
  onApplyChanges,
  onPreviewChanges,
  onRemove,
  isApplying,
  isPreviewing,
  error,
  applyResult,
  previewResult,
}) {
  const previewData = previewResult?.data || {};
  const applyData = applyResult?.data || {};
  const displayNumber = changeNumber || previewData?.originalData?.number || changeId;

  return (
    <div className="list-group-item">
      <h4 className="list-group-item-heading mb-3">
        <div className="name pull-left" style={{ lineHeight: '30px' }}>
          <i className="icon mdi mdi-clipboard-text xs-mr-5"></i>
          {displayNumber}
        </div>
        <span className="btn-group pull-right">
          <ButtonWaiting
            type="button"
            className="btn btn-rounded btn-info"
            onClick={() => onPreviewChanges(changeId)}
            isWaiting={isPreviewing}
            disabled={isApplying || isPreviewing}
          >
            <i className="icon icon-left mdi mdi-eye-outline"></i>
            Preview
          </ButtonWaiting>
          <ButtonWaiting
            type="button"
            className="btn btn-rounded btn-warning"
            onClick={() => onApplyChanges(changeId)}
            isWaiting={isApplying}
            disabled={isApplying || isPreviewing}
          >
            <i className="icon icon-left mdi mdi-pencil-outline"></i>
            Apply Changes
          </ButtonWaiting>
          <button
            type="button"
            className="btn btn-rounded btn-default"
            onClick={() => onRemove(changeId)}
            disabled={isApplying || isPreviewing}
          >
            <i className="icon icon-left mdi mdi-delete"></i>
            Remove
          </button>
        </span>
        <div className="clearfix"></div>
      </h4>

      {(isApplying || isPreviewing) && (
        <BeLoading size={20}>
          {isApplying ? `Applying changes to ${displayNumber}...` : `Previewing changes for ${displayNumber}...`}
        </BeLoading>
      )}

      {error && <BeRemoteErrorAlert error={error} />}

      {previewResult && !error && !isPreviewing && (
        <div className="alert alert-info mt-2 p-2">
          <h6>Preview Results:</h6>
          {previewData?.proposedChanges && Object.keys(previewData.proposedChanges).length > 0 ? (
            <pre className="bg-light p-2 rounded mb-2 small"><code>{JSON.stringify(previewData.proposedChanges, null, 2)}</code></pre>
          ) : (
            <p className="mb-2">No field changes are proposed for this change.</p>
          )}
          {(previewData.attachmentsToDelete?.length || previewData.actionsToDelete?.length || previewData.requestsToDelete?.length) ? (
            <pre className="bg-light p-2 rounded mb-0 small"><code>{JSON.stringify({
              attachmentsToDelete: previewData.attachmentsToDelete || [],
              actionsToDelete: previewData.actionsToDelete || [],
              requestsToDelete: previewData.requestsToDelete || [],
            }, null, 2)}</code></pre>
          ) : null}
        </div>
      )}

      {applyResult && !error && !isApplying && (
        <div className={`alert ${applyResult.ok ? 'alert-success' : 'alert-warning'} mt-2 p-2`}>
          <h6>Apply Results:</h6>
          <pre className="bg-light p-2 rounded mb-0 small"><code>{JSON.stringify(applyData, null, 2)}</code></pre>
        </div>
      )}
    </div>
  );
}

EATDTesterChange.propTypes = {
  changeId: PropTypes.string.isRequired,
  changeNumber: PropTypes.string,
  onApplyChanges: PropTypes.func.isRequired,
  onPreviewChanges: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  isApplying: PropTypes.bool,
  isPreviewing: PropTypes.bool,
  error: PropTypes.object,
  applyResult: PropTypes.object,
  previewResult: PropTypes.object,
};

EATDTesterChange.defaultProps = {
  changeNumber: null,
  isApplying: false,
  isPreviewing: false,
  error: null,
  applyResult: null,
  previewResult: null,
};

export default EATDTesterChange;
